import React from 'react';
import { string, shape } from 'prop-types';

export default function ReducedTradeshowTile({ item, itemDirection }) {
    return (
        <button className={`c-listing-tile c-reduced-tradeshow-tile ${itemDirection}`}>
            {item.thumbnail &&
                <div className="tile-image-wrapper">
                    <div className="tile-image">
                        <img src={item.thumbnail} alt="" />
                    </div>
                </div>
            }
            <div className="tile-content">
                <div className="title">{item.title}</div>
                <div className="date">{item.date}</div>
                <div className="location">{item.location}</div>
            </div>
        </button>
    );
}

ReducedTradeshowTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        thumbnail: string,
        title: string.isRequired,
        subtext: string,
        excerpt: string
    }).isRequired,
    itemDirection: string.isRequired
    /* eslint-enable react/no-typos */
};
